import React from "react";
import AccordionList from "../AccordionList";
import { medicalSideEffectsData } from "./medicalSideEffects.data";


const MedicalSideEffectsAccordionSection: React.FC = () => {
    return (
        <section className="py-10 px-4 md:px-8 max-w-4xl mx-auto">
            <h2 className="text-2xl font-semibold text-center mb-6">Medical Warnings & Side Effects</h2>

            <AccordionList data={medicalSideEffectsData} />
        </section>
    );
};

export default MedicalSideEffectsAccordionSection;
